import * as React from "react";
import { Global } from "@emotion/react";
import { styled } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { grey } from "@mui/material/colors";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Close } from "@mui/icons-material";
import classNames from "classnames";


interface MobileDialogProps {
  open: boolean;
  onClose: () => void;
  onOpen?: () => void;
  title?: string;
  puller?: boolean;
  children: React.ReactNode;
  window?: () => Window;
  height:number;
}

const Root = styled("div")(({ theme }) => ({
  height: "100%",
  backgroundColor:
    theme.palette.mode === "dark"
      ? theme.palette.background.default
      : grey[100],
}));

const StyledBox = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? grey[800] : "#fff",
}));

const Puller = styled("div")(({ theme }) => ({
  width: 30,
  height: 6,
  backgroundColor: theme.palette.mode === "dark" ? grey[900] : grey[300],
  borderRadius: 3,
  position: "absolute",
  top: 8,
  left: "calc(50% - 15px)",
}));

export default function MobileDialog({
  open,
  onClose,
  onOpen,
  title,
  children,
  puller,
  window,
  height,
}: MobileDialogProps) {
  const container =
    window !== undefined ? () => window().document.body : undefined;
    const drawerBleeding = height;

  return (
    <Root>
      <CssBaseline />
      <Global
        styles={{
          ".MuiDrawer-root > .MuiPaper-root": {
            // height: `calc(50% - ${drawerBleeding}px)`,
            overflow: "visible",
          },
        }}
      />
      <SwipeableDrawer
        container={container}
        anchor="bottom"
        open={open}
        onClose={onClose}
        onOpen={onOpen || (() => {})}
        swipeAreaWidth={drawerBleeding}
        disableSwipeToOpen={true}
        keepMounted
      >
        <StyledBox
          sx={{
            position: "absolute",
            top: -drawerBleeding,
            borderTopLeftRadius: 8,
            borderTopRightRadius: 8,
            right: 0,
            left: 0,
          }}
        >
          {puller ? <Puller /> : null}
          {title && (
            <div style={{display:"flex",justifyContent:"space-between",padding:"0px 16px"}}>
            <h3 style={{  color: "#080626",fontSize:"20px",fontFamily:"montserrat-Bold" }}>
                {title}
              </h3>
              <div className="display-flex">
              <Close
                sx={{ cursor: "pointer", color: "#6F6F6F", fontSize: 20 }}
                className={classNames("montserrat-Bold")}
                onClick={onClose}
              />
              </div>
              
            </div>
              
          )}
        </StyledBox>
        <StyledBox
          sx={{
            px: 2,
            pb: 2,
            pt: 1,
            height: "100%",
            overflow: "auto",
          }}
        >
          {children}
        </StyledBox>
      </SwipeableDrawer>
    </Root>
  );
}
